import { render, staticRenderFns } from "./SinglePageSeo.vue?vue&type=template&id=35c64c64&scoped=true&"
import script from "./SinglePageSeo.vue?vue&type=script&lang=js&"
export * from "./SinglePageSeo.vue?vue&type=script&lang=js&"
import style0 from "./SinglePageSeo.vue?vue&type=style&index=0&id=35c64c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c64c64",
  null
  
)

export default component.exports